import { FC } from 'react';
import { Box } from '@mui/material';
import './styles.css';

export const CirclePulsar: FC = (props) => {
    return <Box className="pulsating-circle"/>
}
